<div class="checkbox-container" [formGroup]="formGroup" [class.mdc-component-wrapper]="!editFormFieldInput()">
  @for (input of configJson.inputs; track input.id ?? input.localTrackId; let i = $index) {
    <div class="checkbox-row">
      @if (editFormFieldInput()) {
        <div class="icon-wrapper">
          <button
            aria-label="Edit form field icon button"
            class="icon-button"
            [attr.data-qa]="'edit-form-field-icon-button-' + i"
            (click)="openEditDrawer(i)">
            <i class="fa-regular fa-pen-to-square icon" [class.edit-highlight]="input.selected"></i>
          </button>
          <button
            aria-label="Remove form field icon button"
            class="icon-button"
            mat-button
            [attr.data-qa]="'remove-form-field-icon-button-' + i"
            [disabled]="configJson.inputs.length <= 1"
            (click)="removeField(i)">
            <i class="fa-regular fa-trash-can icon"></i>
          </button>
        </div>
      }

      <mat-checkbox
        class="checkbox-component"
        [aria-label]="input.label ?? 'checkbox-label'"
        [attr.data-qa]="'checkbox-' + i"
        [formControlName]="controlName(input)"
        [class.pointers]="allowPointerEvents"
        (click)="checkboxClick(formGroup.get(controlName(input))?.value, controlName(input))">
        <span class="checkbox-label">{{ input.label }}</span>
        @if (input.isRequired) {
          <span class="required">*</span>
        }
      </mat-checkbox>
    </div>
  }
</div>
@if (showAddCheckboxButton()) {
  <button
    class="plus-sign-button checkbox-add-button"
    data-qa="add-checkbox-button"
    mat-flat-button
    [disabled]="!enableAddTextInputButton()"
    (click)="addInputField()">
    <i class="fa-solid fa-xl font-bold fa-plus"></i> Checkbox
  </button>
}
